module.exports = __webpack_public_path__ + "static/pyramids_orion-73daafa7f9d9680e3e77a0cf8fcb18bf.png";